import { Button, Input } from "components";
import styles from "./styles.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { EnvelopeIcon } from "assets/icons";
import { Link } from "react-router-dom";
import { Routes } from "router";
import { PrecisionLogoMain } from "assets";

interface ForgotData {
  email: string;
}

const schema = yup
  .object({
    email: yup.string().email("Enter a valid email").required("Required"),
  })
  .required();

interface ForgotPasswordUIProps {
  submit: (email: string) => void;
  success: boolean;
  handleLogin: () => void;
}

const ForgotPasswordUI: React.FC<ForgotPasswordUIProps> = ({
  submit,
  success,
  handleLogin,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<ForgotData>({
    resolver: yupResolver(schema),
    defaultValues: { email: "" },
  });

  const onSubmit: SubmitHandler<ForgotData> = (data) => submit(data.email);

  return (
    <div className="">
      <div className="bg-[#26279A] h-[340px] pt-[40px] px-5 lg:hidden flex flex-col">
        <Link to={Routes.home} className="w-fit">
          <PrecisionLogoMain className='w-[180px] flex-shrink-0' />
        </Link>
        <h1 className='text-[23px] font-bold mt-5 text-white w-fit lg:hidden flex'>
          {success ? "Instructions Sent" : "Forgot Password"}
        </h1>
        <p className="text-white text-sm mt-4 lg:text-center lg:hidden flex">
          {success
            ? "Please check your inbox and click the received link to reset your password."
            : "Enter the email address you used when you joined and we'll send you instructions to reset your password."}
        </p>
      </div>
      <div className="lg:w-full w-[90%] mx-auto lg:mt-0 -mt-[80px] rounded-xl lg:p-0 p-4 bg-[#E8F3FF] sm:mb-0 mb-8">
        <h1 className='lg:text-[27px] text-xl font-bold lg:mt-9 mt-6 text-[#012169] w-fit lg:mx-auto lg:block hidden'>
          {success ? "Instructions have been sent" : "Forgot Password"}
        </h1>
        <p className="text-[#475467] text-sm mt-4 lg:text-center lg:flex hidden">
          {success
            ? "Please check your inbox and click the received link to reset your password."
            : "Enter the email address you used when you joined and we'll send you instructions to reset your password."}
        </p>
        {success ? (
          <>
            <div className={styles.success}>
              <p>Didn't receive the email? Check your spam or click the button</p>
              <Button
                className={styles.btn}
                type="fill"
                onClick={() => submit(watch("email"))}
              >
                Resend
              </Button>
            </div>
          </>
        ) : (
          <>
            <form className="lg:mt-7">
              <Input
                label="Email"
                placeholder="email@example.com"
                type="email"
                required
                validatorMessage={errors.email?.message}
                name="email"
                register={register}
                value={watch("email")}
                parentClassName="[&>label]:text-[#344054] [&>label]:font-light !mb-2"
                Icon={EnvelopeIcon}
                iconClassName="!w-4.5 !h-4.5 left-4 !top-11"
                className="!pl-11 !bg-white !border-[#EAECF0] !shadow-none"
              />
              <Button
                className='!bg-[#012169] !border-none w-full text-white !hover:bg-[#012169] !hover:opacity-60 mt-6 mb-3 !py-3 !text-[15px] !rounded-[5px]'
                type="fill"
                onClick={handleSubmit(onSubmit)}
              >
                Send Reset Link
              </Button>
            </form>
            <p className='text-[#2B4682] mx-auto w-fit pt-1'>
              Go back? <Link to={Routes.signin} className="text-[#012169] font-semibold">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export { ForgotPasswordUI };
